var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Page, SimplePagination, Table } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import { TeamList } from '../containers/teamList';
import styles from '../teamPage.module.scss';
import { TeamHeader } from './teamHeader/teamHeader';
export const TEAM_NUMBER_OF_COLUMNS = 1;
export class TeamPage extends PureComponent {
    componentDidMount() {
        const { favourites } = this.props;
        const { filter, isAssignedOnly, searchTerm } = this.props.presenceFilters;
        if (searchTerm) {
            this.props.presence.provideSearchTerm(searchTerm);
        }
        if (typeof isAssignedOnly === 'boolean') {
            this.props.presence.provideAssignedOnly(isAssignedOnly);
        }
        if (filter) {
            this.props.presence.provideFilter(filter);
        }
        this.props.presence.queryItemsWithTotal(favourites);
    }
    componentDidUpdate(prevProps) {
        if (this.props.favourites !== prevProps.favourites) {
            this.props.presence.provideFavourites(this.props.favourites);
        }
    }
    onSearch(values) {
        this.props.presence.searchTermChange(values.team_search);
        this.props.setPresenceFilters(Object.assign(Object.assign({}, this.props.presenceFilters), { searchTerm: values.team_search }));
    }
    handleOnClickFilter(key) {
        const { filterChange } = this.props.presence;
        filterChange(key);
        this.props.setPresenceFilters(Object.assign(Object.assign({}, this.props.presenceFilters), { filter: key }));
        analytics.teamFilterMenuItemClicked({ type: key });
    }
    onNextPageClicked() {
        this.props.presence.nextPage();
        analytics.teamNextPageClicked();
    }
    onPreviousPageClicked() {
        this.props.presence.previousPage();
        analytics.teamPreviousPageClicked();
    }
    onAssignedOnlyClicked() {
        this.props.presence.assignedFilterChange();
        this.props.setPresenceFilters(Object.assign(Object.assign({}, this.props.presenceFilters), { isAssignedOnly: !this.props.presence.isAssignedOnly }));
        analytics.teamAssignedAgentsOnlyClicked();
    }
    onSearchClose() {
        this.props.presence.searchTermChange('');
        this.props.setPresenceFilters(Object.assign(Object.assign({}, this.props.presenceFilters), { searchTerm: '' }));
    }
    renderFoot() {
        const { hasNextPage, hasPreviousPage, itemsAsyncStatus, items } = this.props.presence;
        const hasPagination = items.length > 0 && (hasNextPage || hasPreviousPage);
        if (!hasPagination) {
            return null;
        }
        return (_jsx(Table.Footer, { children: _jsx(SimplePagination, { previousButtonClick: this.onPreviousPageClicked, previousButtonDisabled: !hasPreviousPage, nextButtonClick: this.onNextPageClicked, nextButtonDisabled: !hasNextPage, loading: itemsAsyncStatus === 'loading' }) }));
    }
    render() {
        const { filter, isAssignedOnly, total, itemsAsyncStatus } = this.props.presence;
        return (_jsxs(Page, { children: [_jsx(TeamHeader, { isAssignedOnly: isAssignedOnly, filter: filter, itemsAsyncStatus: itemsAsyncStatus, total: total, searchTerm: this.props.presenceFilters.searchTerm, onAssignedOnlyClicked: this.onAssignedOnlyClicked, onSearchClose: this.onSearchClose, onFilterClick: this.handleOnClickFilter, onSearch: this.onSearch }), _jsx(Page.Body, { children: _jsxs(Table, Object.assign({ framed: false, className: styles.table, wrapperProps: { className: styles.tableWrapper } }, { children: [_jsx(Table.Tbody, { children: _jsx(TeamList, { presence: this.props.presence }) }), this.renderFoot()] })) })] }));
    }
}
__decorate([
    boundMethod
], TeamPage.prototype, "onSearch", null);
__decorate([
    boundMethod
], TeamPage.prototype, "handleOnClickFilter", null);
__decorate([
    boundMethod
], TeamPage.prototype, "onNextPageClicked", null);
__decorate([
    boundMethod
], TeamPage.prototype, "onPreviousPageClicked", null);
__decorate([
    boundMethod
], TeamPage.prototype, "onAssignedOnlyClicked", null);
__decorate([
    boundMethod
], TeamPage.prototype, "onSearchClose", null);
